import moment from "moment";
import { buildPricingReportHTML } from "../htmlBuilder/pricing";
import { CostBreakupReportProps } from "../types";
import { getImageBase64 } from "./helpers";
import { setToHTMLBodyWithGoogleChart } from "../htmlBuilder/htmlHelpers";

export const generateCostBreakupReportV2 = async (payload: CostBreakupReportProps): Promise<string> => {

    let isWebBrowser: boolean = false;

    const apiBaseURL: string = process.env?.REACT_APP_API_BASE_URL ?? "";

    if (apiBaseURL) {
        isWebBrowser = true;
    }

    const builtHTMLPage = await buildPricingReportHTML(payload);

    const pricingHTMLPage = setToHTMLBodyWithGoogleChart(builtHTMLPage.body, builtHTMLPage.script);

    const footer = payload.showFooter ? `
        <div style="width:100%; display:flex; align-items:center; justify-content:flex-end; font-size:8px; padding-right:20px; margin-bottom: -12px; solid #ccc;">
            <a href="${payload.footerURL}" style="color:rgb(125, 125, 125); text-decoration:none;" >Generated using IEHUB on ${moment(new Date()).format("ll")}</a>
        </div>
    ` : ``;

    if (isWebBrowser) {
        const downloadURL = await fetch(apiBaseURL + "html2pdf", {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('auth_token')}`
            },
            body: JSON.stringify({
                html: pricingHTMLPage,
                orientation: payload.orientation,
                paper_size: payload.paperSize,
                footer_template: footer,
                display_header_footer: true,
                margin: {
                    top: "34px",
                    left: "16px",
                    right: "16px",
                    bottom: "16px"
                }
            })
        }).then(res => res.json()).then(async (res) => res.download_url);

        return getImageBase64(downloadURL).then(res => res as string);
    } else {
        return JSON.stringify({
            html: pricingHTMLPage,
            orientation: payload.orientation,
            paper_size: payload.paperSize,
            footer_template: footer,
            display_header_footer: true,
            margin: {
                top: "34px",
                left: "16px",
                right: "16px",
                bottom: "16px"
            }
        });
    }
};
